import React from 'react';
import Icon from '../../../components/AppIcon';

const TrustSignals = () => {
  const trustFeatures = [
    {
      icon: 'Shield',
      title: 'Bank-Level Security',
      description: '256-bit SSL encryption protects your data'
    },
    {
      icon: 'Lock',
      title: 'FINRA Regulated',
      description: 'Fully compliant with financial regulations'
    },
    {
      icon: 'Users',
      title: '500K+ Investors',
      description: 'Trusted by investors worldwide'
    },
    {
      icon: 'Award',
      title: 'Award Winning',
      description: 'Best Investment Platform 2024'
    }
  ];

  const securityBadges = [
    { name: 'SSL Secured', icon: 'Shield' },
    { name: 'SIPC Protected', icon: 'Lock' },
    { name: 'SOC 2 Compliant', icon: 'CheckCircle' }
  ];

  return (
    <div className="space-y-6">
      {/* Main Trust Features */}
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        {trustFeatures.map((feature, index) => (
          <div key={index} className="flex items-start space-x-3 p-3 rounded-lg bg-muted/30">
            <div className="w-8 h-8 bg-primary/10 rounded-full flex items-center justify-center flex-shrink-0">
              <Icon name={feature.icon} size={16} className="text-primary" />
            </div>
            <div className="flex-1">
              <h4 className="text-sm font-medium text-foreground">{feature.title}</h4>
              <p className="text-xs text-muted-foreground mt-1">{feature.description}</p>
            </div>
          </div>
        ))}
      </div>

      {/* Security Badges */}
      <div className="border-t border-border pt-4">
        <div className="flex items-center justify-center space-x-6">
          {securityBadges.map((badge, index) => (
            <div key={index} className="flex items-center space-x-2">
              <Icon name={badge.icon} size={16} className="text-success" />
              <span className="text-xs font-medium text-muted-foreground">{badge.name}</span>
            </div>
          ))}
        </div>
      </div>

      {/* Additional Trust Information */}
      <div className="bg-success/5 border border-success/20 rounded-lg p-4">
        <div className="flex items-start space-x-3">
          <Icon name="Info" size={16} className="text-success mt-0.5" />
          <div className="space-y-1">
            <p className="text-sm font-medium text-success">Your Investment is Protected</p>
            <p className="text-xs text-success/80">
                      Securities in your account are protected up to ₹41,500,000 by SIPC.
        Cash deposits are FDIC insured up to ₹20,750,000.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TrustSignals;